import axios from 'axios'
import { request } from '@/utils/AxiosRequest'

export async function getFcltList(params: any) {
  let getUrl = `/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getFcltList.do?apiKey=${window.SystemConfig.facilityApiKey}&`
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}
// export async function getFcltList(data: any) {
//   return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getFcltList.do?apiKey=${window.SystemConfig.facilityApiKey}&sessionId=${data.sessionId}&sggCd=${data.sggCd}&dodCd=${data.dodCd}&idlFcltPrueSeCdIn=${data.idlFcltPrueSeCdIn}&minAr=${data.minAr}&maxAr=${data.maxAr}&minUseAprvYmd=${data.minUseAprvYmd}&maxUseAprvYmd=${data.maxUseAprvYmd}&searchKeyword=${data.searchKeyword}&pageIndex=${data.pageIndex}`)
// }

export async function getFcltDetail(idlFcltUnqNo: string, id: string) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getFcltDetail.do?apiKey=${window.SystemConfig.facilityApiKey}&sessionId=${id}&idlFcltUnqNo=${idlFcltUnqNo}`)
}
export async function getBuildInfo(params: any, id: string) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getBuildInfo.do?apiKey=${window.SystemConfig.facilityApiKey}&sessionId=${id}&idlFcltUnqNo=${params.idlFcltUnqNo}&flrNo=${params.flrNo}&hoCnt=${params.hoCnt}&brtitleinfoUnqNo=${params.brtitleinfoUnqNo}`)
}

export async function getDlngList(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getDlngList.do?apiKey=${window.SystemConfig.facilityApiKey}&idlFcltUnqNo=${params.idlFcltUnqNo}`)
}

export async function getPopulationInfo(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getPopulationInfo.do?apiKey=${window.SystemConfig.facilityApiKey}&sggCd=${params.sggCd}`)
}

export async function getEnvironmentInfo(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getEnvironmentInfo.do?apiKey=${window.SystemConfig.facilityApiKey}&idlFcltUnqNo=${params.idlFcltUnqNo}`)
}

export async function getFacilityInfo(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getFacilityInfo.do?apiKey=${window.SystemConfig.facilityApiKey}&idlFcltUnqNo=${params.idlFcltUnqNo}`)
}

export async function getTrafficInfo(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getTrafficInfo.do?apiKey=${window.SystemConfig.facilityApiKey}&idlFcltUnqNo=${params.idlFcltUnqNo}`)
}

export async function getBusinessInfo(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getBusinessInfo.do?apiKey=${window.SystemConfig.facilityApiKey}&sidoCd=${params.sidoCd}`)
}

export async function getPrteFarmTurmList(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getPrteFarmTurmList.do?apiKey=${window.SystemConfig.facilityApiKey}&idlFcltUnqNo=${params.idlFcltUnqNo}`)
}

export async function getPrteFarmStyiList(params: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getPrteFarmStyiList.do?apiKey=${window.SystemConfig.facilityApiKey}&idlFcltUnqNo=${params.idlFcltUnqNo}`)
}

export async function getPoiInfo(params: any) {
  return request.get(`/nddt/portal/lxApi/services/lxpf/address/int?serviceKey=tmiKPqf1niMu5rq1VcG49XKIYmhwDJEh&countPerPage=${params.count}&currentPage=${params.page}&keyword=${params.keyword}`)
}

export async function downloadModel(id: string, token: string) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getFcltDetail.do?idlFcltUnqNo=${id}&sessionId=${token}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function ILoad3dTiles(id: string) {
  return axios.post('/nddt/portal/agricultural-land-api/api/r-convert-result/tilesList', {
    approvalId: id,
  }, {
    headers: {
      token: 'dev-test',
    },
  })
}

export async function ILoadWMTS(id: string) {
  return axios.post('/nddt/portal/agricultural-land-api/api/r-convert-result/wmtsList', {
    approvalId: id,
  }, {
    headers: {
      token: 'dev-test',
    },
  })
}
